import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import QRCodeStyling from "qr-code-styling";
import CONFIG from "@bd-core/config";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";

export class ProfilePage extends BD_Component {
    constructor() {
        super();

        this.id = "profile";
        this.template = "profile-template";

        this.elms = {
            cardProfile: "#card-profile-popup",
            cardProfileQrCode: "#card-profile-qr-code",
            cardItem: ".card-item",
            cardItemMainDepartment: "#card-item-main-department",
            cardItemDepartment: "#card-item-department",
            cardItemAvatar: "#card-item-avatar",
            cardItemName: "#card-item-name",
            cardItemRole: "#card-item-role",
            cardItemExperience: "#card-item-experience",
            cardItemDescriptionFull: "#card-profile-description-full",
            cardItemExperienceAction: ".js-card-item-experience",
            cardItemDescriptionOverlay: "#card-profile-description-overlay",
            cardItemDescriptionClose: ".js-profile-description-close",
            // Flip card elements
            flipCard: "#card-profile-flip-card",
            flipToQrBtn: ".js-card-flip-to-qr",
            flipToProfileBtn: ".js-card-flip-to-profile",
            editProfile: "#edit-profile-popup",
            editProfileBtn: ".js-open-edit-profile",
            editProfileClose: "#edit-profile-close",
            editProfileFirstName: "#edit-profile-first-name",
            editProfileLastName: "#edit-profile-last-name",
            editProfileRole: "#edit-profile-role",
            editProfileMainDepartment: "#edit-profile-main-department",
            editProfileMainDepartmentSelect:
                "#edit-profile-main-department-select",
            editProfileMainDepartmentTrigger:
                "#edit-profile-main-department-trigger",
            editProfileMainDepartmentDropdown:
                "#edit-profile-main-department-dropdown",
            editProfileMainDepartmentOptions:
                "#edit-profile-main-department-options",
            editProfileMainDepartmentValue:
                "#edit-profile-main-department-trigger .edit-profile__select-value",
            editProfileDepartment: "#edit-profile-department",
            editProfileDepartmentSelect: "#edit-profile-department-select",
            editProfileDepartmentTrigger: "#edit-profile-department-trigger",
            editProfileDepartmentDropdown: "#edit-profile-department-dropdown",
            editProfileDepartmentOptions: "#edit-profile-department-options",
            editProfileDepartmentValue:
                "#edit-profile-department-trigger .edit-profile__select-value",
            editProfileBizzareExperience: "#edit-profile-bizzare-experience",
            editProfileBizzareExperienceCharCount:
                "#edit-profile-bizzare-experience-char-count",
            editProfileUploadBtn: "#edit-profile-upload-btn",
            editProfileUploadInput: "#edit-profile-upload-input",
            editProfileSave: "#edit-profile-save",
            editProfileAvatarImg: "#edit-profile-avatar-img",
            editProfileAvatarDelete: "#edit-profile-avatar-delete",
            editProfileError: "#edit-profile-error",
            editProfileCurrentAvatar: "#edit-profile-current-avatar",
            profileSavedPopup: "#profile-saved-popup",
            profileSavedPopupOverlay: "#profile-saved-popup-overlay",
            profileSavedPopupOk: "#profile-saved-popup-ok",
            // Achievement popup
            achievementsBtn: ".js-view-achievements",
            achievementsPopup: "#achievement-popup",
            achievementBackBtn: "#achievement-back-btn",
            achievementTab: ".js-achievement-tab",
            // Personal score
            keyMissionsStat: ".js-stat-keys",
            locationMissionsStat: ".js-stat-locations",
            collectedCardsStat: ".js-stat-team-members",
            totalScoreStat: ".js-stat-total-score",
            // Profile info popup (WYSIWYG)
            profileInfoPopup: "#profile-info-popup",
            profileInfoOpen: ".js-profile-info-open",
            profileInfoClose: ".js-profile-info-close",
        };
        this._events = this.getEvents();

        this.qrCodeInstance = null;
        this.qrUpdateInterval = null;
        this.currentQrToken = null;

    }

    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.editProfileBtn,
                handler: this.toggleEditProfile,
            },
            {
                event: "click",
                selector: elms.editProfileClose,
                handler: this.toggleEditProfile,
            },
            {
                event: "click",
                selector: elms.editProfileSave,
                handler: this.saveProfile,
            },
            {
                event: "click",
                selector: elms.profileSavedPopupOk,
                handler: this.closeProfileSavedPopup,
            },
            {
                event: "click",
                selector: elms.profileSavedPopupOverlay,
                handler: this.closeProfileSavedPopup,
            },
            {
                event: "click",
                selector: elms.editProfileUploadBtn,
                handler: this.clickFileInput,
            },
            {
                event: "click",
                selector: elms.editProfileAvatarDelete,
                handler: this.deleteProfilePicture,
            },
            {
                event: "change",
                selector: elms.editProfileUploadInput,
                handler: this.uploadProfilePicture,
            },
            {
                event: "click",
                selector: elms.editProfileMainDepartmentTrigger,
                handler: this.toggleMainDepartmentDropdown,
            },
            {
                event: "click",
                selector: `${elms.editProfileMainDepartmentOptions} .edit-profile__select-option`,
                handler: this.selectMainDepartmentOption,
            },
            {
                event: "click",
                selector: elms.editProfileDepartmentTrigger,
                handler: this.toggleDepartmentDropdown,
            },
            {
                event: "click",
                selector: `${elms.editProfileDepartmentOptions} .edit-profile__select-option`,
                handler: this.selectDepartmentOption,
            },
            {
                event: "input",
                selector: elms.editProfileBizzareExperience,
                handler: this.updateCharCount,
            },
            {
                event: "click",
                selector: elms.cardItemExperienceAction,
                handler: this.toggleCardItemOverlay,
            },
            {
                event: "click",
                selector: elms.cardItemDescriptionClose,
                handler: this.toggleCardItemOverlay,
            },
            {
                event: "click",
                selector: elms.flipToQrBtn,
                handler: this.toggleFlipCard,
            },
            {
                event: "click",
                selector: elms.flipToProfileBtn,
                handler: this.toggleFlipCard,
            },
            {
                event: "click",
                selector: elms.achievementsBtn,
                handler: this.toggleAchievementsPopup,
            },
            {
                event: "click",
                selector: elms.achievementBackBtn,
                handler: this.toggleAchievementsPopup,
            },
            {
                event: "click",
                selector: elms.achievementTab,
                handler: this.onAchievementTabClick,
            },
            {
                event: "click",
                selector: elms.profileInfoOpen,
                handler: this.openProfileInfoPopup,
            },
            {
                event: "click",
                selector: elms.profileInfoClose,
                handler: this.closeProfileInfoPopup,
            },
        ];
    }

    async beforeInit() {
        const data = await this.fetchProfile();
        if (data) {
            Object.assign(this._data, {
                user_profile: data.user_profile,
                achievements: data.achievements ?? [],
                achievement_stats: data.achievement_stats ?? {},
                user_stats: data.user_stats ?? {},
            });
            if (data.collected_achievements_label) {
                this._data.text_settings = this._data.text_settings ?? {};
                this._data.text_settings.collected_achievements_label =
                    data.collected_achievements_label;
            }
        }
        this.render();
        this.setGameState();
    }

    /**
     * Fetch profile and achievements in a single request (user_profile with rarity, team, achievements).
     * @returns {Promise<Object|null>} Profile payload or null on failure.
     */
    async fetchProfile() {
        const [response] = await bdjs.goAsync(bdapi.post("game/get-profile"));
        if (response?.data?.success && response?.data?.data) {
            return response.data.data;
        }
        return null;
    }

    setPlaceholderTxt(content, placeholderTag, value) {
        return content.replace(placeholderTag, value);
    }

    modifyData() {
        // Shape achievement data for the achievement popup (from API).
        const achievements = this._data.achievements ?? [];
        const allItems = this.flattenAchievementSteps(achievements);
        const categorized = this.categorizeAchievementItems(allItems);
        this._data.achievementItemsKeyMissions = categorized.keyMissions;
        this._data.achievementItemsLocationMissions = categorized.locationMissions;
        this._data.achievementItemsCollection = categorized.collection;

        return this._data;
    }

    /**
     * Flatten achievements with steps into a single list for the achievement popup.
     * @param {Array} achievements - Array of achievements (each with type and steps array)
     * @returns {Array} Flat list of step items for display, each with type
     */
    flattenAchievementSteps(achievements) {
        if (!Array.isArray(achievements)) return [];
        const items = [];
        for (const achievement of achievements) {
            const steps = achievement.steps || [];
            const type = achievement.type || "players";
            for (const step of steps) {
                items.push({
                    icon: step.icon || "",
                    title: step.title || "",
                    description: step.description || "",
                    points: step.points ?? 0,
                    amount: step.amount ?? 0,
                    is_completed: Boolean(step.is_completed),
                    current_amount: step.current_amount ?? 0,
                    progress_percentage: step.progress_percentage ?? 0,
                    type,
                });
            }
        }
        return items;
    }

    /**
     * Split flattened achievement items into key missions, location missions, and collection.
     * @param {Array} items - Flat list from flattenAchievementSteps
     * @returns {{ keyMissions: Array, locationMissions: Array, collection: Array }}
     */
    categorizeAchievementItems(items) {
        const keyMissions = [];
        const locationMissions = [];
        const collection = [];
        for (const item of items) {
            if (item.type === "key_missions") keyMissions.push(item);
            else if (item.type === "location_missions") locationMissions.push(item);
            else collection.push(item);
        }
        return { keyMissions, locationMissions, collection };
    }

    toggleAchievementsPopup() {
        const elms = this.elms;
        $(elms.achievementsPopup).toggleClass("active");
    }

    openProfileInfoPopup() {
        const elms = this.elms;
        $(elms.profileInfoPopup).addClass("active");
    }

    closeProfileInfoPopup() {
        const elms = this.elms;
        $(elms.profileInfoPopup).removeClass("active");
    }

    /**
     * Switches achievement popup tab and shows the corresponding panel.
     */
    onAchievementTabClick(_, el) {
        const $tab = $(el);
        const tabKey = $tab.data("tab");
        const $popup = $tab.closest("#achievement-popup");
        if (!tabKey || !$popup.length) return;

        $popup
            .find(".js-achievement-tab")
            .removeClass("is-active")
            .attr("aria-selected", "false");
        $tab.addClass("is-active").attr("aria-selected", "true");

        $popup
            .find(".achievement-popup__panel")
            .removeClass("is-panel-active")
            .attr("hidden", true);
        $popup
            .find(`#achievement-panel-${tabKey}`)
            .addClass("is-panel-active")
            .removeAttr("hidden");
    }

    render() {
        const data = this.modifyData();

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
    }

    /**
     * Set the initial game state for the profile page.
     */
    setGameState() {
        this.toggleProfileCardVisibility();
        this.populateMainDepartmentDropdown();
        this.populateDepartmentDropdown(this._data.user_profile?.main_department_id ?? null);
        this.detectBackfaceVisibility();

        if (!CONFIG.game.isProfileCreated) return;

        this.populateCardItem();
        this.populateEditForm();
        this.updateProfileCardQrCode();
        this.populatePersonalScore();

        if (this.qrUpdateInterval) {
            clearInterval(this.qrUpdateInterval);
            this.qrUpdateInterval = null;
        }
        const qrCodeMode = CONFIG.game?.qr_code_mode ?? "static";
        const qrCodeExpiryMs = CONFIG.game?.qr_code_expiry_ms ?? 5 * 60 * 1000;
        if (qrCodeMode === "dynamic" && qrCodeExpiryMs > 0) {
            this.qrUpdateInterval = setInterval(() => {
                this.updateProfileCardQrCode();
            }, qrCodeExpiryMs);
        }
    }

    /**
     * Toggle profile card visibility based on profile creation status.
     */
    toggleProfileCardVisibility() {
        const isProfileCreated = CONFIG.game.isProfileCreated;
        $(this.elms.cardProfile).toggleClass(
            "active",
            Boolean(isProfileCreated),
        );
    }

    /**
     * Populate the main department dropdown with available main departments.
     */
    populateMainDepartmentDropdown() {
        const mainDepartments = CONFIG.game.main_departments;
        const elms = this.elms;

        if (mainDepartments.length === 0) return;

        $(elms.editProfileMainDepartment).empty();
        $(elms.editProfileMainDepartment).append(
            `<option value="" disabled selected>Select main department</option>`,
        );

        $(elms.editProfileMainDepartmentOptions).empty();

        mainDepartments.forEach((dept) => {
            $(elms.editProfileMainDepartment).append(
                `<option value="${dept.id}">${dept.title}</option>`,
            );
            $(elms.editProfileMainDepartmentOptions).append(
                `<div class="edit-profile__select-option" data-value="${dept.id}">${dept.title}</div>`,
            );
        });
    }

    /**
     * Populate the department dropdown with departments of the given main department.
     *
     * @param {string|number|null} mainDepartmentId - Main department ID, or null for empty/placeholder only.
     */
    populateDepartmentDropdown(mainDepartmentId) {
        const elms = this.elms;
        const mainDepartments = CONFIG.game.main_departments ?? [];
        const mainDept = mainDepartmentId
            ? mainDepartments.find(
                (d) => String(d.id) === String(mainDepartmentId),
            )
            : null;
        const departments = mainDept?.departments ?? [];

        // Populate native select (hidden, for form submission)
        $(elms.editProfileDepartment).empty();
        $(elms.editProfileDepartment).append(
            `<option value="" disabled selected>Select department</option>`,
        );

        // Populate custom dropdown options
        $(elms.editProfileDepartmentOptions).empty();

        departments.forEach((department) => {
            $(elms.editProfileDepartment).append(
                `<option value="${department.id}">${department.title}</option>`,
            );
            $(elms.editProfileDepartmentOptions).append(
                `<div class="edit-profile__select-option" data-value="${department.id}">${department.title}</div>`,
            );
        });
    }

    /**
     * Toggle the main department custom dropdown.
     */
    toggleMainDepartmentDropdown(e) {
        e.preventDefault();
        e.stopPropagation();
        const elms = this.elms;
        const $select = $(elms.editProfileMainDepartmentSelect);
        const isOpen = $select.hasClass("is-open");

        if (isOpen) {
            $select.removeClass("is-open");
            $(document).off("click.mainDepartmentDropdown");
        } else {
            $select.addClass("is-open");
            setTimeout(() => {
                $(document).on("click.mainDepartmentDropdown", (event) => {
                    if (
                        !$(event.target).closest(
                            elms.editProfileMainDepartmentSelect,
                        ).length
                    ) {
                        $select.removeClass("is-open");
                        $(document).off("click.mainDepartmentDropdown");
                    }
                });
            }, 10);
        }
    }

    /**
     * Handle main department option selection.
     */
    selectMainDepartmentOption(e) {
        const elms = this.elms;
        const $option = $(e.currentTarget);
        const value = $option.data("value");
        const text = $option.text();

        $(elms.editProfileMainDepartment).val(value);
        $(elms.editProfileMainDepartmentValue).text(text).addClass("has-value");

        $(elms.editProfileMainDepartmentOptions)
            .find(".edit-profile__select-option")
            .removeClass("is-selected");
        $option.addClass("is-selected");

        $(elms.editProfileMainDepartmentSelect).removeClass("is-open");
        $(document).off("click.mainDepartmentDropdown");

        this.populateDepartmentDropdown(value);
        $(elms.editProfileDepartment).val("");
        $(elms.editProfileDepartmentValue)
            .text("Select department")
            .removeClass("has-value");
        $(elms.editProfileDepartmentOptions)
            .find(".edit-profile__select-option")
            .removeClass("is-selected");
    }

    /**
     * Toggle the department custom dropdown.
     */
    toggleDepartmentDropdown(e) {
        e.preventDefault();
        e.stopPropagation();
        const elms = this.elms;
        const $select = $(elms.editProfileDepartmentSelect);
        const isOpen = $select.hasClass("is-open");

        // Close dropdown
        if (isOpen) {
            $select.removeClass("is-open");
            $(document).off("click.departmentDropdown");
        } else {
            // Open dropdown
            $select.addClass("is-open");

            // Close on outside click
            setTimeout(() => {
                $(document).on("click.departmentDropdown", (event) => {
                    if (
                        !$(event.target).closest(
                            elms.editProfileDepartmentSelect,
                        ).length
                    ) {
                        $select.removeClass("is-open");
                        $(document).off("click.departmentDropdown");
                    }
                });
            }, 10);
        }
    }

    /**
     * Handle department option selection.
     */
    selectDepartmentOption(e) {
        const elms = this.elms;
        const $option = $(e.currentTarget);
        const value = $option.data("value");
        const text = $option.text();

        // Update native select value
        $(elms.editProfileDepartment).val(value);

        // Update custom select display
        $(elms.editProfileDepartmentValue).text(text).addClass("has-value");

        // Update selected state
        $(elms.editProfileDepartmentOptions)
            .find(".edit-profile__select-option")
            .removeClass("is-selected");
        $option.addClass("is-selected");

        // Close dropdown
        $(elms.editProfileDepartmentSelect).removeClass("is-open");
        $(document).off("click.departmentDropdown");
    }

    /**
     * Populate the card item display with user profile data.
     */
    populateCardItem() {
        const elms = this.elms;
        const userProfile = this._data.user_profile;

        $(elms.cardItem).addClass(`card-item--${userProfile.rarity_level}`);
        $(elms.cardItemMainDepartment).text(
            userProfile.main_department?.title ?? "",
        );
        $(elms.cardItemDepartment).text(userProfile.department?.title ?? "");
        $(elms.cardItemAvatar).attr("src", userProfile.avatar);
        $(elms.cardItemName).text(
            userProfile.first_name + " " + userProfile.last_name,
        );
        $(elms.cardItemRole).text(userProfile.role);

        if (userProfile.bizzare_experience.length > 75) {
            $(elms.cardItemExperience).addClass("is-truncated");
            $(elms.cardItemExperience).text(
                userProfile.bizzare_experience.substring(0, 75) + "...",
            );
        } else {
            $(elms.cardItemExperience).text(userProfile.bizzare_experience);
        }
        $(elms.cardItemDescriptionFull).text(userProfile.bizzare_experience);

        // Update flip card rarity for QR code background
        this.updateFlipCardRarity();
    }

    populatePersonalScore() {
        const elms = this.elms;
        const userStats = this._data.user_stats ?? {};

        $(elms.keyMissionsStat).text(userStats.total_key_missions);
        $(elms.locationMissionsStat).text(userStats.total_location_missions);
        $(elms.collectedCardsStat).text(userStats.total_collected_cards);
        $(elms.totalScoreStat).text(userStats.total_points);
    }

    /**
     * Populate the edit form fields with user profile data.
     */
    populateEditForm() {
        const elms = this.elms;
        const userProfile = this._data.user_profile;

        $(elms.editProfileFirstName).val(userProfile.first_name);
        $(elms.editProfileLastName).val(userProfile.last_name);
        $(elms.editProfileRole).val(userProfile.role);
        $(elms.editProfileMainDepartment).val(userProfile.main_department_id);
        $(elms.editProfileBizzareExperience).val(
            userProfile.bizzare_experience,
        );
        $(elms.editProfileAvatarImg).attr("src", userProfile.avatar);
        $(elms.editProfileCurrentAvatar).val(userProfile.avatar || "");

        // Initialize character count
        this.updateCharCount();

        // Update custom select display for main department
        if (userProfile.main_department_id && userProfile.main_department) {
            $(elms.editProfileMainDepartmentValue)
                .text(userProfile.main_department.title)
                .addClass("has-value");
            $(elms.editProfileMainDepartmentOptions)
                .find(
                    `.edit-profile__select-option[data-value="${userProfile.main_department_id}"]`,
                )
                .addClass("is-selected");
        } else {
            $(elms.editProfileMainDepartmentValue)
                .text("Select main department")
                .removeClass("has-value");
            $(elms.editProfileMainDepartmentOptions)
                .find(".edit-profile__select-option")
                .removeClass("is-selected");
        }

        this.populateDepartmentDropdown(userProfile.main_department_id);

        // Update custom select display for department (only if still in main's list)
        const mainDept = userProfile.main_department_id
            ? (CONFIG.game.main_departments ?? []).find(
                (d) =>
                    String(d.id) ===
                    String(userProfile.main_department_id),
            )
            : null;
        const allowedDeptIds =
            mainDept?.departments?.map((d) => String(d.id)) ?? [];
        const departmentInList =
            userProfile.department_id &&
            allowedDeptIds.includes(String(userProfile.department_id));

        if (departmentInList && userProfile.department) {
            $(elms.editProfileDepartment).val(userProfile.department_id);
            $(elms.editProfileDepartmentValue)
                .text(userProfile.department.title)
                .addClass("has-value");
            $(elms.editProfileDepartmentOptions)
                .find(
                    `.edit-profile__select-option[data-value="${userProfile.department_id}"]`,
                )
                .addClass("is-selected");
        } else {
            $(elms.editProfileDepartment).val("");
            $(elms.editProfileDepartmentValue)
                .text("Select department")
                .removeClass("has-value");
            $(elms.editProfileDepartmentOptions)
                .find(".edit-profile__select-option")
                .removeClass("is-selected");
        }
    }

    toggleEditProfile() {
        const elms = this.elms;

        $(elms.editProfile).toggleClass("active");
    }

    /**
     * Normalize line breaks for consistent length (Safari/iOS counts \r\n as 2).
     *
     * @param {string} text - Raw textarea value.
     * @returns {string} Text with \r\n and \r replaced by \n.
     */
    normalizeLineBreaks(text) {
        if (typeof text !== "string") return "";
        return text.replace(/\r\n|\r/g, "\n");
    }

    /**
     * Map selection (start/end) from a string with \r\n to the same positions
     * in the normalized string (each \r\n becomes \n, so indices shift left).
     *
     * @param {string} value - Raw value that may contain \r\n.
     * @param {number} start - Selection start in value.
     * @param {number} end - Selection end in value.
     * @returns {{ start: number, end: number }} Selection in normalized string.
     */
    selectionAfterNormalize(value, start, end) {
        const beforeStart = (value.substring(0, start).match(/\r\n|\r/g) || [])
            .length;
        const beforeEnd = (value.substring(0, end).match(/\r\n|\r/g) || [])
            .length;
        return {
            start: Math.max(0, start - beforeStart),
            end: Math.max(0, end - beforeEnd),
        };
    }

    /**
     * Enforce maxlength on the bizzare experience textarea in JS so that line
     * breaks count as one character (fixes Safari/iOS \r\n counting as 2).
     * When at limit, reverts to last valid value and restores cursor so input
     * is prevented instead of trimming from the end.
     */
    enforceTextareaMaxLength() {
        const elms = this.elms;
        const textarea = $(elms.editProfileBizzareExperience);
        const el = textarea.get(0);
        const maxLength = parseInt(textarea.attr("data-maxlength"), 10) || 500;
        const value = textarea.val();
        const normalized = this.normalizeLineBreaks(value);

        let lastValid = this._bizzareExperienceLastValid;
        if (lastValid == null) {
            lastValid = {
                value: normalized,
                start: Math.min(el.selectionStart, normalized.length),
                end: Math.min(el.selectionEnd, normalized.length),
            };
            this._bizzareExperienceLastValid = lastValid;
        }

        if (normalized.length > maxLength) {
            textarea.val(lastValid.value);
            el.setSelectionRange(lastValid.start, lastValid.end);
            return;
        }

        if (normalized !== value) {
            const start = el.selectionStart;
            const end = el.selectionEnd;
            textarea.val(normalized);
            const sel = this.selectionAfterNormalize(value, start, end);
            el.setSelectionRange(sel.start, sel.end);
            this._bizzareExperienceLastValid = {
                value: normalized,
                start: sel.start,
                end: sel.end,
            };
        } else {
            this._bizzareExperienceLastValid = {
                value: normalized,
                start: el.selectionStart,
                end: el.selectionEnd,
            };
        }
    }

    /**
     * Update character count indicator for bizzare experience textarea.
     * Enforces maxlength in JS (Safari counts \r\n as 2) then uses normalized length for display.
     */
    updateCharCount() {
        this.enforceTextareaMaxLength();

        const elms = this.elms;
        const textarea = $(elms.editProfileBizzareExperience);
        const charCountEl = $(elms.editProfileBizzareExperienceCharCount);
        const maxLength = parseInt(textarea.attr("data-maxlength"), 10) || 500;
        const normalized = this.normalizeLineBreaks(textarea.val());
        const currentLength = normalized.length;

        charCountEl.text(`${currentLength} / ${maxLength}`);
    }

    /**
     * Validate profile form data.
     *
     * @param {Object} data - The form data to validate.
     * @returns {Object} - Object with isValid boolean and errors array.
     */
    validateProfileData(data) {
        const errors = [];

        errors.push(
            ...this.validateTextField(
                data.firstName,
                "first_name",
                "First name",
                50,
            ),
        );
        errors.push(
            ...this.validateTextField(
                data.lastName,
                "last_name",
                "Last name",
                50,
            ),
        );
        errors.push(...this.validateTextField(data.role, "role", "Role", 100));
        errors.push(...this.validateMainDepartment(data.mainDepartment));
        errors.push(
            ...this.validateDepartment(data.department, data.mainDepartment),
        );
        errors.push(
            ...this.validateTextField(
                data.bizzareExperience,
                "bizzare_experience",
                "Bizarre experience",
                500,
            ),
        );
        errors.push(
            ...this.validateProfilePicture(
                data.profilePicture,
                data.currentAvatar,
            ),
        );

        return {
            isValid: errors.length === 0,
            errors,
        };
    }

    /**
     * Validate text field.
     *
     * @param {string} value - Field value.
     * @param {string} fieldName - Field name for error.
     * @param {string} displayName - Display name for error message.
     * @param {number} maxLength - Maximum length.
     * @returns {Array} Array of errors.
     */
    validateTextField(value, fieldName, displayName, maxLength) {
        const errors = [];
        const text_settings = this._data.text_settings;
        const profile_validation_messages = text_settings.profile_validation_messages;

        if (!value || value.length === 0) {
            errors.push({
                field: fieldName,
                // message: `${displayName} is required`,
                message: profile_validation_messages[`${fieldName}_required`],
            });
        } else if (value.length > maxLength) {
            errors.push({
                field: fieldName,
                message: profile_validation_messages[`${fieldName}_character_limit`].replace("{maxLength}", maxLength),
            });
        }

        return errors;
    }

    /**
     * Validate main department selection.
     *
     * @param {string} mainDepartment - Main department ID.
     * @returns {Array} Array of errors.
     */
    validateMainDepartment(mainDepartment) {
        const errors = [];
        const text_settings = this._data.text_settings;
        const profile_validation_messages = text_settings.profile_validation_messages;
        const { main_department_required, select_valid_main_department } = profile_validation_messages;

        if (!mainDepartment || mainDepartment.length === 0) {
            errors.push({
                field: "main_department",
                message: main_department_required,
            });
            return errors;
        }

        const mainDepartments = CONFIG.game.main_departments;
        const validIds = mainDepartments.map((dept) => String(dept.id));

        if (!validIds.includes(mainDepartment)) {
            errors.push({
                field: "main_department",
                message: select_valid_main_department,
            });
        }

        return errors;
    }

    /**
     * Validate department selection against the selected main department's departments.
     *
     * @param {string} department - Department ID.
     * @param {string} mainDepartmentId - Main department ID.
     * @returns {Array} Array of errors.
     */
    validateDepartment(department, mainDepartmentId) {
        const errors = [];
        const text_settings = this._data.text_settings;
        const profile_validation_messages = text_settings.profile_validation_messages;
        const { before_select_department_message, department_required, select_valid_department } = profile_validation_messages;

        if (!mainDepartmentId || String(mainDepartmentId).length === 0) {
            errors.push({
                field: "department",
                message: before_select_department_message,
            });
            return errors;
        }

        if (!department || department.length === 0) {
            errors.push({
                field: "department",
                message: department_required,
            });
            return errors;
        }

        const mainDepartments = CONFIG.game.main_departments ?? [];
        const mainDept = mainDepartments.find(
            (d) => String(d.id) === String(mainDepartmentId),
        );
        const validDepartmentIds = (mainDept?.departments ?? []).map((d) =>
            String(d.id),
        );

        if (!validDepartmentIds.includes(String(department))) {
            errors.push({
                field: "department",
                message: select_valid_department,
            });
        }

        return errors;
    }

    /**
     * Validate profile picture file.
     *
     * @param {File} file - File object.
     * @param {string} currentAvatar - Current avatar URL.
     * @returns {Array} Array of errors.
     */
    validateProfilePicture(file, currentAvatar = "") {
        const errors = [];
        const text_settings = this._data.text_settings;
        const profile_validation_messages = text_settings.profile_validation_messages;
        const { profile_picture_required, profile_picture_max_size_limit, allowed_image_files } = profile_validation_messages;

        if (!file && !currentAvatar) {
            errors.push({
                field: "profile_picture",
                message: profile_picture_required,
            });
            return errors;
        }

        if (!file) {
            return errors;
        }

        const maxSize = 5 * 1024 * 1024;
        const allowedTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "image/gif",
            "image/webp",
        ];

        if (file.size > maxSize) {
            const sizeInMB = maxSize / 1024 / 1024;
            const message = profile_picture_max_size_limit.replace("{maxSize}", sizeInMB);
            errors.push({
                field: "profile_picture",
                message: message,
            });
        }

        if (!allowedTypes.includes(file.type)) {
            const allowedTypesString = "(JPEG, PNG, GIF, or WebP)";
            const message = allowed_image_files.replace("{allowedTypes}", allowedTypesString);

            errors.push({
                field: "profile_picture",
                message:
                    message,
            });
        }

        return errors;
    }

    /**
     * Display validation errors.
     *
     * @param {Array} errors - Array of error objects.
     */
    displayErrors(errors) {
        const elms = this.elms;
        const $errorContainer = $(elms.editProfileError);

        if (errors.length === 0) {
            $errorContainer.hide().text("");
            return;
        }

        const errorMessages = errors.map((error) => error.message).join("<br>");
        $errorContainer.html(errorMessages).show();

        $errorContainer[0]?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
    }

    /**
     * Clear validation errors.
     */
    clearErrors() {
        const elms = this.elms;
        $(elms.editProfileError).hide().text("");
    }

    /**
     * Save profile data.
     */
    async saveProfile() {
        this.clearErrors();

        const formData = this.getFormData();
        const validation = this.validateProfileData(formData);

        if (!validation.isValid) {
            this.displayErrors(validation.errors);
            return;
        }

        try {
            this.setSaveButtonLoading(true);

            const [res, err] = await bdjs.goAsync(
                bdapi.post("game/save-profile", this.prepareFormData(formData)),
            );

            if (err) {
                this.handleApiError(
                    "An error occurred while saving your profile. Please try again.",
                );
                return;
            }

            if (res?.data?.success === false) {
                this.handleApiError(
                    res.data.data?.message || "Failed to save profile",
                    res.data.data?.field,
                );
                return;
            }

            this.handleSaveSuccess(res?.data?.data?.avatar_url);
        } catch (error) {
            this.handleApiError(
                "An unexpected error occurred. Please try again.",
            );
        } finally {
            this.setSaveButtonLoading(false);
        }
    }

    /**
     * Get form data values.
     *
     * @returns {Object} Form data object.
     */
    getFormData() {
        return {
            firstName: $(this.elms.editProfileFirstName).val()?.trim() || "",
            lastName: $(this.elms.editProfileLastName).val()?.trim() || "",
            role: $(this.elms.editProfileRole).val()?.trim() || "",
            bizzareExperience:
                $(this.elms.editProfileBizzareExperience).val()?.trim() || "",
            mainDepartment:
                $(this.elms.editProfileMainDepartment).val()?.trim() || "",
            department: $(this.elms.editProfileDepartment).val()?.trim() || "",
            profilePicture: $(this.elms.editProfileUploadInput).prop(
                "files",
            )[0],
            currentAvatar: $(this.elms.editProfileCurrentAvatar).val() || "",
        };
    }

    /**
     * Prepare FormData for API request.
     *
     * @param {Object} data - Form data object.
     * @returns {FormData} FormData instance.
     */
    prepareFormData(data) {
        const formData = new FormData();
        formData.append("first_name", data.firstName);
        formData.append("last_name", data.lastName);
        formData.append("role", data.role);
        formData.append("main_department", data.mainDepartment);
        formData.append("department", data.department);
        formData.append("bizzare_experience", data.bizzareExperience);

        if (data.profilePicture) {
            formData.append("profile_picture", data.profilePicture);
        } else if (data.currentAvatar) {
            formData.append("current_avatar", data.currentAvatar);
        }

        return formData;
    }

    /**
     * Handle API error response.
     *
     * @param {string} message - Error message.
     * @param {string} field - Error field.
     */
    handleApiError(message, field = "general") {
        this.displayErrors([
            {
                field,
                message,
            },
        ]);
    }

    /**
     * Handle successful save. Shows "Profiel opgeslagen" popup on top; user clicks OK then we go back to profile page.
     *
     * @param {string} avatarUrl - Avatar URL.
     */
    handleSaveSuccess(avatarUrl) {
        const elms = this.elms;

        if (avatarUrl) {
            $(elms.editProfileAvatarImg).attr("src", avatarUrl);
        }

        this.clearErrors();
        // Show success popup first (on top of edit form); do not close edit yet.
        $(elms.profileSavedPopup).addClass("active");
    }

    /**
     * Close profile-saved popup, then close edit form and reload to profile page.
     */
    closeProfileSavedPopup() {
        const elms = this.elms;
        $(elms.profileSavedPopup).removeClass("active");
        $(elms.editProfile).removeClass("active");
        window.location.reload();
    }

    /**
     * Set save button loading state.
     *
     * @param {boolean} isLoading - Loading state.
     */
    setSaveButtonLoading(isLoading) {
        const elms = this.elms;
        $(elms.editProfileSave)
            .prop("disabled", isLoading)
            .text(isLoading ? "Saving..." : "Save");
    }

    clickFileInput() {
        const elms = this.elms;
        $(elms.editProfileUploadInput).click();
    }

    uploadProfilePicture() {
        const elms = this.elms;
        const profilePicture = $(elms.editProfileUploadInput).prop("files")[0];

        $(elms.editProfileAvatarImg).attr(
            "src",
            URL.createObjectURL(profilePicture),
        );
    }

    deleteProfilePicture() {
        const elms = this.elms;
        $(elms.editProfileAvatarImg).attr(
            "src",
            CONFIG.game.avatarPlaceholderURL,
        );
    }

    toggleCardItemOverlay() {
        const elms = this.elms;
        $(elms.cardItemDescriptionOverlay).toggleClass("active");
    }

    toggleFlipCard() {
        const elms = this.elms;
        $(elms.flipCard).toggleClass("is-flipped");
    }

    /**
     * Detect if backface-visibility: hidden is likely broken on this device.
     * Uses User-Agent detection for browsers with known backface-visibility bugs
     * (primarily Samsung Internet Browser).
     * If broken, adds 'no-backface-visibility' class to trigger the CSS crossfade fallback.
     */
    detectBackfaceVisibility() {
        const elms = this.elms;
        const $flipCard = $(elms.flipCard);

        // Skip if already applied
        if (this._backfaceDetected) return;
        this._backfaceDetected = true;

        // Samsung Internet Browser is known to have broken backface-visibility support.
        // Other browsers (Chrome, Firefox, Safari) handle it correctly.
        const ua = navigator.userAgent || "";
        const isSamsungBrowser = /SamsungBrowser/i.test(ua);

        if (isSamsungBrowser) {
            $flipCard.addClass("no-backface-visibility");
        }
    }

    /**
     * Generate QR code data URL with a server-signed token.
     * @returns {Promise<string|null>} QR code data URL
     */
    async generateQrData() {
        const userId = this._data?.user_profile?.user_id ?? 0;

        if (!userId) {
            return null;
        }

        const [response] = await bdjs.goAsync(
            bdapi.post("game/qr-token"),
        );

        if (!response?.data?.success || !response.data.data?.token) {
            console.warn("Failed to generate QR token.");
            return null;
        }

        this.currentQrToken = response.data.data.token;

        return `${CONFIG.siteURL}/?user_id=${userId}&token=${encodeURIComponent(this.currentQrToken)}`;
    }

    /**
     * Generate and append QR code to the profile card flip side (#card-profile-qr-code).
     */
    async updateProfileCardQrCode() {
        const $qrCodeElement = $(this.elms.cardProfileQrCode);
        const qrCodeElement = $qrCodeElement[0];

        if (!qrCodeElement) return;

        const qrData = await this.generateQrData();
        if (!qrData) return;

        qrCodeElement.innerHTML = "";

        const containerWidth = $qrCodeElement.width();
        const availableWidth = containerWidth || 200;
        const qrSize = Math.max(200, Math.min(availableWidth, 200));

        this.qrCodeInstance = new QRCodeStyling({
            width: qrSize,
            height: qrSize,
            type: "svg",
            data: qrData,
            margin: 10,
            image: CONFIG.game.qrLogoURL,
            dotsOptions: {
                color: "#000000",
                type: "square",
                roundSize: false,
            },
            cornersSquareOptions: {
                color: "#000000",
                type: "square",
            },
            cornersDotOptions: {
                color: "#000000",
                type: "square",
            },
            backgroundOptions: {
                color: "#ffffff",
            },
        });

        this.qrCodeInstance.append(qrCodeElement);
    }

    /**
     * Update the flip card rarity attribute based on card item rarity.
     */
    updateFlipCardRarity() {
        const elms = this.elms;
        const $cardItem = $(elms.cardItem);
        const $flipCard = $(elms.flipCard);

        // Extract rarity level from card-item class
        const cardClasses = $cardItem.attr("class") || "";
        const rarityMatch = cardClasses.match(/card-item--lv(\d)/);

        if (rarityMatch) {
            $flipCard.attr("data-rarity", `lv${rarityMatch[1]}`);
        }
    }
}
